var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack350({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.4,10.74V5.37H8.06a1.73,1.73,0,0,1,.79.16A1.11,1.11,0,0,1,9.33,6a1.42,1.42,0,0,1,.19.73,1.35,1.35,0,0,1-.16.67,1.22,1.22,0,0,1-.46.47,1.21,1.21,0,0,1,.61.48,1.44,1.44,0,0,1,.22.82,1.82,1.82,0,0,1-.2.86,1.26,1.26,0,0,1-.53.54,2.14,2.14,0,0,1-.92.16ZM7,7.63h1a2.07,2.07,0,0,0,.53,0,.67.67,0,0,0,.35-.26A.86.86,0,0,0,9,6.83a.85.85,0,0,0-.12-.48.58.58,0,0,0-.29-.27A2.1,2.1,0,0,0,7.87,6H7Zm0,2.48H8.08A1.5,1.5,0,0,0,8.62,10,.72.72,0,0,0,9,9.73a1.15,1.15,0,0,0,.13-.55A.92.92,0,0,0,9,8.67a.71.71,0,0,0-.33-.31A1.57,1.57,0,0,0,8,8.26H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack350);
export default __webpack_public_path__ + "static/media/Symbol_pack_350.1ced4bcd2bedb211c6517a4fde3c782f.svg";
export { ForwardRef as ReactComponent };